import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { CheckRegisterToken } from "../Api/UserOperations/CheckRegisterToken";

const CheckToken = () => {
  const query = useParams();
  const navigate = useNavigate();
  const getResult = async () => {
    const { data } = await CheckRegisterToken(query);
    if (data.status) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: "Email verify success",
      });

      navigate("/Login");
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: "Incorrect Token!",
      });
      navigate("/");
    }
  };

  useEffect(() => {
    getResult();
    //eslint-disable-next-line
  }, []);

  return <div></div>;
};
export default CheckToken;
